module.exports = __webpack_public_path__ + "img/03.b6762e1a.png";